// MandatListPage.jsx
import '../styles/PageGlobal.css';
import './MandatListPage.css';
import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { MandatService } from '../services/MandatService';



export default function MandatListPage() {
  const navigate = useNavigate();
  
  const [mandats, setMandats] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  
  // ── Data loader ─────────────────────────────────────────────────────────────
  const fetchMandats = useCallback(async () => {
  setLoading(true);
  try {
    const mandatService = new MandatService();

    const data = await mandatService.fetchMandats();
    setMandats(data);
    console.log(data);
  } catch (err) {
    setError(err.message);
  } finally {
    setLoading(false);
  }
}, []);

  useEffect(() => {
    fetchMandats();
  }, [fetchMandats]);

  // ── Navigation handlers (preserve your original logic) ─────────────────────
  const handleEditMandat = (id) => {
    navigate(`/mandat_edit/${id}`);
  };

  // ── Action handlers (pattern-aligned) ───────────────────────────────────────
  const handleCloture = async (id) => {
     const mandatService = new MandatService();

  if (!window.confirm('Confirmer la clôture ?')) return;
  await mandatService.closeMandat(id);
  await fetchMandats();
};

 const handleDownloadPdf = async (mandatId) => {
  try {
    const mandatService = new MandatService();
    await mandatService.downloadPdf(mandatId);
  } catch (err) {
    alert("Erreur téléchargement PDF : " + err.message);
  }
};

  // ── Render guards ────────────────────────────────────────────────────────────
  if (loading) return <div className="mandat-status mandat-status-loading">Chargement…</div>;
  if (error) return <div className="mandat-status mandat-status-error">{error}</div>;

  // ── Render ──────────────────────────────────────────────────────────────────
  return (
    <div className="containerMain mandat-container">
      {/* Header */}
      <div className="mandat-header">
        <h1 className="mandat-title">Liste des Mandats</h1>
        <div className="mandat-header-actions">
          {/* Your original buttons preserved */}
          
        </div>
      </div>

      <p className="mandat-protected">Ceci est un contenu protégé</p>

      {/* Table like TVA example */}
      <div className="mandat-table-wrapper">
        <table className="mandat-table">
          <thead>
            <tr>
              <th>N</th>
              <th>Référence</th>
              <th>Client</th>
              <th>Bon de commande</th>
              <th>Date</th>
              <th>Lignes</th>
              <th>Total HT</th>
              <th>Statut</th>
              <th>Action</th>
            </tr>
          </thead>
                    <tbody>
            {mandats.map((mandat, index) => (
              <tr key={mandat.id}>
                <td>{index + 1}</td>
                <td className="mandat-ref">{mandat.reference || 'N/A'}</td>
                <td>{mandat.clientNom || 'N/A'}</td>
                <td>{mandat.bonCommande || 'N/A'}</td>
                <td>{mandat.dateCreation || 'N/A'}</td>
                <td>{mandat.lignesCount ?? 0}</td>
                
                {/* 🟢 CORRECTION ICI : Ajout de "|| 0" pour éviter l'erreur si totalHT est undefined */}
                <td>{(mandat.totalHT || 0).toFixed(2)} €</td>
                
                <td>
                  <span className={`mandat-statut-badge statut-${(mandat.status || 'inconnu').toLowerCase().replace(' ', '-')}`}>
                    {mandat.status || 'Inconnu'}
                  </span>
                </td>
                <td className="mandat-action-cell">
                <button
                  className="mandat-btn mandat-btn-yellow"
                  onClick={() => handleEditMandat(mandat.id)}
                >
                  Edit
                </button>

                <button
                  className="mandat-btn mandat-btn-blue"
                  onClick={() => handleCloture(mandat.id)}
                >
                  Clôturer
                </button>

                <button
                  className="mandat-btn mandat-btn-pdf"
                  onClick={() => handleDownloadPdf(mandat.id)}
                >
                  PDF
                </button>
              </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Footnotes */}
      <div className="mandat-footnotes">
        <p>* Cliquez sur "Edit" pour modifier un mandat existant</p>
        
      </div>
    </div>
  );
}